import { useState } from "react";

const FAQS = [
  {
    q: "対応可能な地域はどこですか？",
    a: "国内を対象としています。現地確認が必要な案件については、場所・内容・日程を確認のうえ対応可否をご相談します。初回打ち合わせはオンラインでも対応可能です。",
  },
  {
    q: "扱っている技術領域は限定されますか？",
    a: "金属加工、樹脂成形、ガラス加工、蒸着・コーティング、組立・検査工程を主な対象としています。個別の現象については、対応可能か事前に確認します。",
  },
  {
    q: "情報の秘密性が心配です。",
    a: "必要に応じてNDAを締結します。技術情報・工程情報・データの取り扱いには十分配慮します。",
  },
  {
    q: "どのくらいの期間で結果が出ますか？",
    a: "案件により異なりますが、原因究明・改善設計は通常1〜2か月を想定しています。必要な検証内容によっては、最大3か月程度となる場合があります。",
  },
  {
    q: "改善効果が出なかった場合はどうなりますか？",
    a: "原因究明・改善設計費20万円は発生しますが、改善効果が確認できない場合、成果報酬は発生しません。",
  },
  {
    q: "検証・実験は誰が実施しますか？",
    a: "原則として、お客様側で実施いただきます。こちらは検証方法、条件設定、評価方法の設計を支援します。",
  },
  {
    q: "他社のコンサルティング会社や分析会社との違いは？",
    a: "分析結果や報告書を提示して終わるのではなく、現象の観察から原因の絞り込み、改善案、評価方法まで一連で整理することを重視しています。また、改善効果と連動した成果報酬型の料金体系を採用しています。",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-24 md:py-32 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">FAQ</span>
            <div className="w-8 h-[1px] bg-primary-500" />
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug">
            <a href="#faq" className="cursor-pointer">よくあるご質問</a>
          </h4>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`border rounded-lg transition-colors ${
                  isOpen
                    ? "bg-background-50 border-primary-300"
                    : "bg-background-100 border-background-200"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-start justify-between gap-6 text-left p-5 md:p-6 cursor-pointer"
                >
                  <div className="flex items-start gap-4 flex-1 min-w-0">
                    <div className="w-7 h-7 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xs font-heading">
                      Q
                    </div>
                    <span className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                      {f.q}
                    </span>
                  </div>
                  <div
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md text-foreground-600 transition-transform ${
                      isOpen ? "rotate-180 text-primary-500" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </div>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-6 pl-16 md:pl-[68px]">
                    <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}